module.exports = __webpack_public_path__ + "static/media/portugues.21446e53.png";